import {
  COMPONENT_VALUE_TYPES as types,
  BUTTON_SIZE,
  BUTTON_POSITION,
  REGIONS
} from 'shared/constants';

const propsSchema = [
  {
    key: 'background_color',
    label: 'Background Color',
    type: types.COLOR_PICKER,
  },
  {
    key: 'cta',
    label: 'CTA',
    type: types.OBJECT,
    children: [
      {
        key: 'region',
        label: 'Region',
        type: types.ENUM,
        options: REGIONS
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT_WITH_ICON,
        children: [
          { key: 'text', label: 'Text' },
          { key: 'icon', label: 'Icon' },
          { key: 'icon_size', label: 'IconSize' },
          { key: 'placement', label: 'Placement' },
        ],
      },
      {
        key: 'iOSStoreLink',
        label: 'iOS Store link',
        type: types.TEXT,
      },
      {
        key: 'iOSAppLink',
        label: 'iOS App link',
        type: types.TEXT,
      },
      {
        key: 'androidStoreLink',
        label: 'Android Store Link',
        type: types.TEXT,
      },
      {
        key: 'androidAppLink',
        label: 'Android App Link',
        type: types.TEXT,
      },
      {
        key: 'androidApkLink',
        label: 'Android Apk Link',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'size',
    label: 'Button Size',
    type: types.ENUM,
    options: BUTTON_SIZE,
  },
  {
    key: 'size_cust',
    label: 'Button Size Customization',
    type: types.OBJECT,
    children: [
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT,
      },
      {
        key: 'height',
        label: 'Height',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'position',
    label: 'Button Position',
    type: types.ENUM,
    options: BUTTON_POSITION,
  },
];

const defaultProps = {
  background_color: '#000000',
  cta: {
    region: 'US',
    label: {
      text: 'INSTALL APP',
      icon: 'ff-icon-check',
      placement: 'AFTER',
    },
    iOSStoreLink: 'https://itunes.apple.com/us/app/id1454187098',
    iOSAppLink: 'https://faradayfuture.app.link',
    androidStoreLink: 'https://play.google.com/store/apps/details?id=com.faradayfuture.online',
    androidAppLink: 'faradayfuture://feed',
    androidApkLink: 'https://www.faradayfuturecn.com/cn/apk/latest.apk',
  },
  size: 'LARGE',
  position: 'CENTER',
};

export default {
  title: 'App Download Button',
  id: 'AppDownloadButton',
  widgetImage: '/widgetImages/Button.png',
  propsSchema,
  defaultProps,
};
